import {useTranslation} from 'react-i18next';
import {Radio} from '@mui/material';
import { FormQuestion, FormQuestionLinearScaleType } from '../../../../services/operations/forms';

type Props = {
  question: FormQuestion;
  value: number | null;
  onChange: (value: number | null) => void;
};

function PublicLinearScale({question, value, onChange}: Props) {
  const {t} = useTranslation();

  const {
    min: fromValue,
    max: toValue,
    minLabel: fromLabel,
    maxLabel: toLabel,
  } = question?.linearScale as FormQuestionLinearScaleType;

  // Generate array of scale values [fromValue, ..., toValue]
  const scaleValues: number[] = [];
  for (let i = fromValue; i <= toValue; i++) {
    scaleValues.push(i);
  }

  const handleSelect = (val: number) => {
    onChange(val);
  };

  const handleClear = () => {
    onChange(null);
  };

  return (
    <div className="flex flex-col gap-3 mt-3">
      {/* Scale row: fromLabel — radio circles — toLabel */}
      <div className="flex items-center justify-center gap-6">
        {/* From label */}
        {toLabel && (
          <span className="text-2xl text-textColor flex-shrink-0">
            {toLabel}
          </span>
        )}

        {/* Radio circles with number labels */}
        <div className="flex flex-wrap md:flex-nowrap flex-row-reverse items-center gap-3 md:!gap-10">
          {scaleValues.map((val) => {
            const isSelected = value === val;
            return (
              <label
                key={val}
                className="flex flex-col items-center gap-1 cursor-pointer"
              >
                {/* Number label */}
                <span className="text-textColor">{val}</span>

                {/* Radio circle */}
                <Radio
                  color="secondary"
                  checked={isSelected}
                  value={val}
                  onChange={() => handleSelect(val)}
                  sx={{ padding: 0 }}
                />
              </label>
            );
          })}
        </div>

        {/* To label */}
        {fromLabel && (
          <span className="text-2xl text-textColor flex-shrink-0">
            {fromLabel}
          </span>
        )}
      </div>

      {/* Clear selection link */}
      <div className="flex">
        <button
          type="button"
          onClick={handleClear}
          className="text-linkBlue underline hover:opacity-80 transition-opacity"
        >
          {t("forms.public.clearSelection")}
        </button>
      </div>
    </div>
  );
}

export default PublicLinearScale;
